import castArray from 'lodash/castArray';

const defaultTransform = item => ({ label: item.name, value: item.id });

export default (list, transform = defaultTransform) => castArray(list).map(transform);
